import React from 'react';
import { GridApi } from '@ag-grid-community/core';
import { LinkItem, PopoverListCellRenderer } from '@urc-ui/components/udc-table/cell-renderers/popover-list-cell-renderer';
import { useAdvertisers } from '@urc-ui/hooks/advertisers/use-advertiser-info';
import { getBaseurl } from '@urc-ui/utils/url-utils';
import { getEntityId } from '@urc-ui/store/api/base';
import { TAKT_EVENT, TAKT_EVENT_SOURCE, useTaktLogger } from '@urc-ui/hooks/takt-logger';
import { Subscription } from '@urc-ui/store/api/subscriptions/types';

interface AccountCellProps {
  value: {
    subscription: Subscription;
    api: GridApi;
  };
}

export const AccountCell = (props: AccountCellProps) => {
  const { subscription, api } = props.value;
  const { isLoading, advertisers } = useAdvertisers(subscription.accounts as string[], api);
  const { logCustomTaktEvent } = useTaktLogger({ subscription });

  const onAdvertiserNameClick = () =>
    logCustomTaktEvent({ eventName: TAKT_EVENT.OPEN_ADVERTISER_ORDER, source: TAKT_EVENT_SOURCE.SUBSCRIPTION_TABLE });

  const items = advertisers.map(advertiser => {
    return {
      text: advertiser.name,
      url: advertiser.cfid ? `${getBaseurl()}/dsp/${getEntityId()}/advertisers/${advertiser.cfid}/orders` : ''
    };
  }) as LinkItem[];

  const value = {
    items,
    isLoading,
    pluralsStringId: 'sspa_rcm_ad_reports_formatted_accounts',
    defaultPluralsString: '{0} accounts',
    onClickEvent: onAdvertiserNameClick
  };

  return <PopoverListCellRenderer value={value} />;
};
